import { useTranslation } from 'react-i18next';
import AllergenIcon from './AllergenIcon';
import type { AllergenCode } from './allergens';

/** Au-delà, « +N » : mesuré à 360 px (≈150 px utiles), 4 pictogrammes de 14 px + « +N »
 *  (80 px) tiennent à côté d'un prix courant ; la rangée passe sous un prix long. */
export const CARD_MAX_ICONS = 4;

interface Props {
  /** `undefined` = non renseigné, `[]` = renseigné sans allergène : rien dans les deux cas. */
  codes: AllergenCode[] | undefined;
}

export default function AllergenRow({ codes }: Props) {
  const { t } = useTranslation();
  if (!codes || codes.length === 0) return null;
  const shown = codes.slice(0, CARD_MAX_ICONS);
  const hidden = codes.length - shown.length;
  // L'étiquette nomme TOUS les allergènes, pas seulement les pictogrammes visibles.
  const list = codes.map((c) => t(`menu.allergens.names.${c}`)).join(t('menu.allergens.listSeparator'));
  const label = t('menu.allergens.a11yLabel', { list });
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      data-testid="dish-allergens"
      className="inline-flex shrink-0 items-center gap-[3px] text-[var(--ink-mute)]"
    >
      {shown.map((c) => (
        <AllergenIcon key={c} code={c} size={14} className="shrink-0" />
      ))}
      {hidden > 0 && (
        <span aria-hidden="true" className="shrink-0 font-mono text-[11px] leading-none">
          {t('menu.allergens.more', { count: hidden })}
        </span>
      )}
    </span>
  );
}
